import template from './documents-table-tbody.pug';

export const DocumentsTableTbodyComponent = {
  template,
  bindings: {
    filter: '<',
    records: '<',
    checkedIds: '<',
    gridOptions: '<?',
    onFilterChange: '&',
    isModal: '<?',
    onCheck: '&'
  },
  controller: class DocumentsTableTbodyComponent {
    constructor($stateParams, $state, Document, AlertBox, $async, $log) {
      'ngInject';

      this.Document = Document;
      this.$state = $state;
      this.AlertBox = AlertBox;
      this.$stateParams = $stateParams;
      this.$log = $log;
      this.isVisible = false;
      this.getRecord = $async(this.getRecord.bind(this));
    }

    $onInit() {}

    $onChanges({ checkedIds, records } = {}) {
      if (checkedIds && checkedIds.currentValue && checkedIds.currentValue.length == 0) {
        this.records &&
          this.records.forEach(record => {
            record.checked = false;
          });
      }
      if (records && records.currentValue) {
        this.gridOptions.data = records.currentValue.map(x => {
          return (x.attributes = { ...x.attributes, ...x.attributes['custom_fields'] });
        });
      }
    }

    checkIds({ checkedIds }) {
      this.onCheck({ $event: { checkedIds } });
    }

    updateFilter() {
      const params = {
        filter: this.filter,
        searchId: this.$stateParams.searchId
      };
      this.applyFilter(params);
    }

    applyFilter({ filter, searchId }) {
      this.onFilterChange({
        $event: { filter, searchId }
      });
    }

    preview({ row }) {
      this.getRecord(row.entity.id);
    }

    close() {
      this.isVisible = false;
    }

    async getRecord(id) {
      try {
        const record = await this.Document.find(id);
        this.selectedRecord = record;
        this.isVisible = true;
      } catch (e) {
        this.$log.error(e);
      }
    }
  }
};
